import { render, staticRenderFns } from "./quick-detail.vue?vue&type=template&id=212f0f44&scoped=true&"
import script from "./quick-detail.vue?vue&type=script&lang=js&"
export * from "./quick-detail.vue?vue&type=script&lang=js&"
import style0 from "./quick-detail.vue?vue&type=style&index=0&id=212f0f44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212f0f44",
  null
  
)

export default component.exports